import React, { useState, useEffect } from "react";

import UserSideMenu from "../../menu/UserSideMenu";
import { axiosInstnace as Axios, calculateAmountAndTax } from "../../util/util";
import { endPoints } from "../../config";
import { history } from "../../history/history";
import Header from "../common/HeaderAfterLogin";
import Pagination from "../admin/common/Pagination";
import {ShowStations} from "./ShowStations";

const CampaignList = (props) => {
  //Set initial state
  const [campaigns, handleCampaignList] = useState([]);
  const [noDataClass, handleNoDataClass] = useState("none");
  const [dataClass, handleDataClass] = useState("none");
  const [count, handleCount] = useState(0);
  const [skip, handleSkip] = useState(0);
  const [showstationlist, handleshowstationlist] = useState(false);
  const [currentStations, handleCurrentStations] = useState([]);
  useEffect(() => {
    getCampaignlist(0);
    let loc = props;
  }, []);

  const hideshowstations = (e) => {
    handleshowstationlist(!showstationlist);
  };
  //Fetching the campign list
  const getCampaignlist = async (skip, name) => {
    handleSkip(skip);
    try {
      const data = await Axios.get(endPoints.campaignList, {
        params: {
          skip,
          userEmail: JSON.parse(localStorage.getItem("userInfo")).email,
          name,
        },
      });
      let result = data.data.data.data;
      if (result && result.length > 0) {
        result = result.map((r, i) => {
          return calculateAmountAndTax(r, true);
        });
        handleCampaignList(result);
        handleNoDataClass("none");
        handleDataClass("");
        handleCount(data.data.data.count);
      } else if (result && result.length === 0 && name) {
        handleCampaignList(result);
        handleNoDataClass("none");
        handleDataClass("");
      } else if (result && result.length === 0 && !name) {
        handleNoDataClass("");
        handleDataClass("none");
      }

      if (props.location.state && props.location.state.updatedCampaign) {
        let { updatedCampaign } = props.location.state;
        let data = result.find((e) => {
          return e._id === updatedCampaign._id;
        });
        props.getCampaignDetails(data, result);
        props.onSubmit();
      }
    } catch (error) {
      console.log(error);
    }
  };

  //searching the ampaign
  const getSearch = (e) => {
    if (e.target.value.length > 0) {
      getCampaignlist(0, e.target.value);
    } else {
      getCampaignlist(0);
    }
  };

  const getCampaignDetail = (data, overall) => {
    props.getCampaignDetails(data, overall);
    props.onSubmit();
  };

  //Return the table that cantain campaign info
  return (
    <div className="main_wrapper">
      <UserSideMenu {...props} />{" "}
      <div className="dashboard_right_wrapper">
        <div className="right_wrapper_inner">
          <Header />
          <div className="dash_content_wrapper">
            <div className="content_wrapper_inner">
              <div className={`camp_wrapper ${dataClass}`}>
                <div className="running_cap_head">
                  {" "}
                  <h2 className="camp_head"> CAMPAIGNS </h2>
                  <div className="camp_right">
                    <div className="search_name">
                      <span className="search_img">
                        <img src="../../assets/images/search.png" />
                      </span>
                      <input
                        type="text"
                        placeholder="Search here by Campaign Name"
                        onChange={getSearch}
                      />
                    </div>{" "}
                    <div className="create_camp_btn">
                      <button
                        onClick={() => {
                          history.push({
                            pathname: "/package",
                          });
                        }}
                      >
                        CREATE CAMPAIGN{" "}
                      </button>{" "}
                    </div>{" "}
                  </div>{" "}
                </div>{" "}
                <div className="camp_listing_wrapper">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th> S.No </th> <th> Campaign ID </th>{" "}
                        <th> Campaign Name </th> <th> Product Category </th>{" "}
                        <th> Package Type </th> <th> Station </th>{" "}
                        <th>
                          Price{" "}
                          <img
                            src="../../assets/images/rupee-indian.svg"
                            className="camp_rupee"
                          />
                        </th>{" "}
                        <th> Status </th> <th> Action </th>{" "}
                      </tr>{" "}
                    </thead>{" "}
                    <tbody>
                      {" "}
                      {campaigns.map((c, i) => (
                        <tr key={i}>
                          <td> {i + 1} </td> <td> {c._id} </td>{" "}
                          <td> {c.name} </td> <td> {c.product} </td>{" "}
                          <td> {c.type} </td>{" "}
                          <td>
                            {c.station.includes(",") ? (
                              <a
                                onClick={(e) => {
                                  debugger;
                                  handleshowstationlist(true);
                                  handleCurrentStations(c.station.split(","));
                                }}
                              >
                                Multiple ({c.station.split(",").length})
                              </a>
                            ) : (
                              c.station
                            )}
                          </td>{" "}
                          <td> {c.totalCost} </td>{" "}
                          <td
                            className={
                              c.status == "Pending"
                                ? "new"
                                : c.status === "RO Approved"
                                ? "audio_approved"
                                : c.status === "Audio Rejected"
                                ? "audio_rejected"
                                : "ro_approved"
                            }
                          >
                            {c.payId && c.status}
                            {!c.payId && c.status == "Pending" && c.paymentDetails.length == 0 && "Failed"}
                            {!c.payId && c.status == "Pending" && c.transactionProof && "Verification Pending"}
                            {!c.payId && c.status == "Pending" && c.paymentDetails.length > 0 && "Verification Pending"}
                          </td>{" "}
                          <td>
                            <a
                              className="view_list"
                              onClick={getCampaignDetail.bind(
                                this,
                                c,
                                campaigns
                              )}
                            >
                              VIEW{" "}
                            </a>{" "}
                          </td>{" "}
                          {c.pendingAmount > 0 &&
                            (c.status === "Audio Approved" ||
                              c.status === "On-Hold") && !c.transactionProof && (
                              <td>
                                <a
                                  className="view_list"
                                  onClick={getCampaignDetail.bind(
                                    this,
                                    c,
                                    campaigns
                                  )}
                                >
                                  Pay{" "}
                                </a>{" "}
                              </td>
                            )}{" "}
                          {!c.payId && c.status == "Pending" && c.paymentDetails.length == 0 && !c.transactionProof && (
                            <td>
                              <a
                                className="view_list"
                                onClick={getCampaignDetail.bind(
                                  this,
                                  c,
                                  campaigns
                                )}
                              >
                                Pay{" "}
                              </a>{" "}
                            </td>
                          )}
                         
                        </tr>
                      ))}{" "}
                    </tbody>{" "}
                  </table>{" "}
                  <div className="paginationTable">
                    {" "}
                    {(skip > 0 || count >= 10) && (
                      <Pagination
                        getAllData={getCampaignlist}
                        totalRecords={count}
                      />
                    )}{" "}
                  </div>{" "}
                </div>{" "}
              </div>{" "}
              
              {/* <div className="listing_footer">
                                    <div className="listing_footer_left">
                                    </div>
                                    <div className="listing_footer_right">
                                    </div>
                                  </div> */}
              <div className={`bookcampaign ${noDataClass}`}>
                <div>
                  <img src="../../assets/images/radio.png" />
                </div>{" "}
                <div className="book_camp_para">
                  <p> It seems like you don 't have any campaign' s yet </p>{" "}
                </div>{" "}
                <div className="book_camp_btn">
                  <button
                    onClick={() => {
                      window.location.href = "/package";
                    }}
                  >
                    BOOK CAMPAIGNS{" "}
                  </button>{" "}
                </div>{" "}
              </div>{" "}
            </div>{" "}
          </div>{" "}
        </div>{" "}
      </div>{" "}
      {showstationlist && (
                <ShowStations
                  stations={currentStations}
                  closeAction={hideshowstations}
                />
              )}
    </div>
  );
};
export default CampaignList;



// WEBPACK FOOTER //
// ./web/components/campaign/dashboard.js